export const addPossibleAnswerAction = function (item, form) {
    return {
        type: "FB_ADD_POSSIBLE_ANSWER",
        payload: item, 
        form
    }
};

export const setPossibleAnswersAction = function (items, form) {
    return {
        type: "FB_SET_POSSIBLE_ANSWERS",
        payload: items, 
        form
    }
};

export const removePossibleAnswerAction = function (item, form) {
    return {
        type: "FB_REMOVE_POSSIBLE_ANSWER",
        payload: item, 
        form
    }
};

export const clearPossibleAnswersAction = function () {
    return {
        type: "FB_CLEAR_POSSIBLE_ANSWERS"
    }
};

export const changePossibleAnswerAction = function (item, form) {
    return {
        type: "FB_CHANGE_POSSIBLE_ANSWER",
        payload: item, 
        form
    }
};


// WEBPACK FOOTER //
// ./src/redux/creators/form-builder/possibleAnswers.js